<template>
    <div class="tw-events tw-stage tw-responsive__xs--half-padding tw-responsive__xxs--half-padding">
        <div v-if="dmnOptions.widgetMode === 'default-view'" class="tw-grid__row" id="event-list-top">
            <div class="tw-grid__col--50 tw-grid__colxs--100 tw-grid__collg--33" v-for="event in events" :key="event._id" v-on:click="chooseEvent(event)" v-on:mouseover="mouseHoverEvent(event)" v-on:mouseleave="mouseLeaveEvent(event)">
                <div class="tw-item tw-item--selectable tw-item--split" v-scroll-to="'#tonic-ticket-widget'">
                    <div class="tw-item__photo-container" v-if="!dmnOptions.hideEventPhotos && !event.showEventListDescription">
                        <div class="tw-sold-out__event" v-if="event.is_sold_out" style="width: 100%; height: 100%; position: absolute">
                            <h3>SORRY, THIS HAS SOLD OUT</h3>
                        </div>
                        <div class="tw-item__photo" v-bind:style="{ 'background-image': 'url(' + event.photo + ')' }"></div>
                    </div>
                    <div class="tw-item__photo-container" v-show="event.showEventListDescription">
                        <div class="tw-item__photo tw-item__description" v-html="event.event_list_description"></div>
                    </div>
                    <div class="tw-item__details">
                        <h4 class="tw-text--flush">{{ event.title }}</h4>
                        <p v-if="event.venue_title" class="tw-text--flush">
                            <font-awesome-icon icon="at" />
                            {{event.venue_title}}
                        </p>
                        <p>
                            <span>
                                <font-awesome-icon :icon="['far', 'calendar']" />
                                {{getEventDate(event)}}
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="dmnOptions.widgetMode === 'list-view'" class="tw-grid__row">
            <div class="tw-grid__col--100 tw-grid__colxs--100 tw-grid__collg--33 tw-accordion-events" v-for="event in events" :key="event._id" v-on:click="chooseEvent(event)">
                <div class="tw-item tw-item--selectable tw-item--split" v-scroll-to="'#accordion-top'">
                    <div class="tw-item__details">
                        <p class="tw-text--flush">
                            {{ event.title }}
                        </p>
                        <p class="tw-text--flush">
                            <span class="tw-margin-gutter-right" v-if="event.venue_title">
                                <font-awesome-icon icon="at" />
                                {{ event.venue_title }}
                            </span>

                            <span v-if="event.venue_address && event.venue_address.postcode">
                                - {{ event.venue_address.postcode }}
                            </span>
                        </p>
                        <p class="tw-text--flush">
                            <span>
                                <font-awesome-icon :icon="['far', 'calendar']" />
                                {{getEventDate(event)}}
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Vue } from "vue-property-decorator";
    import { Component } from "vue-property-decorator";
    import TicketWidgetComponent from '../TicketWidgetComponent';
    import Event from '../../models/Event';
    import CurrencyConfig from '../../constants/CurrencyConfig';
    import moment from 'moment-timezone';

    //fontawesome
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import { faAt } from '@fortawesome/free-solid-svg-icons';
    import { faCalendar } from '@fortawesome/free-regular-svg-icons';

    library.add(faCalendar, faAt);

    @Component({
        components: {
            FontAwesomeIcon
        }
    })

    export default class EventsList extends TicketWidgetComponent {
        mounted() {
            // force the window to do a resize event so the widget loads correctly
            var windowEvent = window.document.createEvent('HTMLEvents'); 
            windowEvent.initEvent('resize', true, false); 
            window.dispatchEvent(windowEvent);
        }

        /**
        * @param {Event} event
        */
        mouseHoverEvent(event: Event) {
            if(event.event_list_description) {
                event.showEventListDescription = true;

                this.$forceUpdate();
            }
        }

        /**
        * @param {Event} event
        */
        mouseLeaveEvent(event: Event) {
            event.showEventListDescription = false;

            this.$forceUpdate();
        }

        /**
        * @param {Event} event
        */
        chooseEvent(event: Event) {
            this.selectedEvent = event;
            this.cartManager.event = event;
            this.dataProviderService.selectedEvent = event;

            this.setVueCurrency(event);

            // Reset the cartManager incase there are still quantities selected from another event
            this.cartManager.resetCart();

            if(this.dmnOptions.widgetMode === 'default-view') {
                this.$router.push({ path: 'calendar' });
            }
            else {
                this.$root.$emit('eventSelected', event);
            }
        }

        /**
         * @param {Event} event
         */
        setVueCurrency(event: Event) {
            // set currency to the events currency
            (<any>Vue).currencyFilterConfig.symbol = (<any>CurrencyConfig.currencies)[event.currency].symbol;
        }

        /**
         * @param {Event} event
         */
        getEventDate(event: any) {
            let dateString = '';
            let dateDescription = event.getDateDescription();

            let nextDate = event.recurrenceModel.getNextDate(moment().subtract(1, 'days'));

            if(nextDate) {
                dateString = nextDate.format('dddd, Do MMMM YYYY');
            }

            if(dateDescription) {
                dateString = dateString + ' (' + dateDescription + ')';
            }

            return dateString;
        }
    }
</script>